import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isAuthenticated: false,
  access_token: null,
  refresh_token: null,
  account_id: null,
  account_balance: 0,
  user_role: null,
}

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated
    },
    setTokens: (state, action) => {
      state.access_token = action.payload.access_token
      state.refresh_token = action.payload.refresh_token
    },
    setProfile: (state, action) => {
      state.account_id = action.payload.account_id
      state.account_balance = action.payload.account_balance
      state.user_role = action.payload.user_role
    },
    setAccountBalance: (state, action) => {
      state.account_balance = action.payload.account_balance
    },
    profileReset: () => {
      return { ...initialState }
    }
  }
})

export const { 
  setIsAuthenticated,
  setTokens,
  setProfile,
  setAccountBalance,
  setUserRole,
  profileReset,
} = profileSlice.actions

export default profileSlice.reducer